import { render } from "./popup.vue?vue&type=template&id=a0de64dc&scoped=true&ts=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"

import "./popup.vue?vue&type=style&index=0&id=a0de64dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0de64dc"]])

export default __exports__